module.exports = __webpack_public_path__ + "img/manda_006.da7a990f.png";